import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Input from "../../components/uiComponent/inputs/input/index"
import ReactSelect from '../../components/uiComponent/select';
import FileUpload from '../../components/uiComponent/upload/uploadNew';
import Button from "../../components/uiComponent/button/index";
import { GetAllUsers } from '../../slices/work-orders';
import { cloneDeep, isEmpty, startCase } from 'lodash';


import ErrorIcon from "../../assets/icons/error-red.svg"
import PartyIcon from "../../assets/icons/party-popper-icon.svg"

import { StepDataWrapper } from './style'

const StepsData = ({
  setAddProduct,
  setDataToProceed,
  currentStep,
  setCurrentStep,
  setFileData,
  setFileList,
  setFileColumns,
  setFileRows,
  dataToProceed,
  fileData,
  fileRows,
  fileList,
  fileColumns,
  clearStates,
  sampleFileLink,
  setSelectedUser,
  bulkAddInventory = false

  }) => {

  const dispatch = useDispatch();

  const { rows } = fileData || {};

  const {
    usersList,
    fetchingAllUsers,
  } = useSelector((state) => state.workOrders || {});

  const {
    currentUser,
  } = useSelector((state) => state.auth || {});

  
  const handleFileValueChange = (event, label) => {
    const mapping = cloneDeep(dataToProceed);
    const alreadyIndex = mapping?.findIndex(val => val.value === event);
    if (alreadyIndex !== -1) mapping[alreadyIndex] = { ...mapping[alreadyIndex], value: '', data: [] };
    const data = rows.map(item => item[event]);
    const index = mapping.findIndex(col => col.label === label);
    mapping[index] = { ...mapping[index], value: event, data };
    setDataToProceed(mapping);
  };

  useEffect(()=> {
    dispatch(GetAllUsers());
  }, [])

  const isSellerPlusWarehouse = currentUser?.role?.id === 5;
  
  useEffect(() => {
    if (!isEmpty(dataToProceed)) {
      const dataLength = dataToProceed[0].data.length;
      const originalData = Array.from({ length: dataLength }, (_, index) => {
        const obj = {};
        dataToProceed.forEach(item => {
          obj[item.label] = item.data[index];
        });
        return obj;
      });
      setFileRows(originalData);
    }
  }, [dataToProceed]);
  return (
    <StepDataWrapper>
      {currentStep === 3 ? null :<div className='box-wrapper'>
        {
          currentStep === 1 && !bulkAddInventory && !!setSelectedUser && !isSellerPlusWarehouse && (
            <ReactSelect
              placeholder={'Select Users'}
              options={usersList}
              isClearable
              important
              loading={fetchingAllUsers}
              onChange={(selectedOption) => {
                setSelectedUser(selectedOption || {});
              }}
            />
          )
        }
        <header>
          <h6>{currentStep === 2 ? 'Review Errors' : bulkAddInventory ? 'Add Inventory' : 'Inventory Adjustment'}</h6>
        </header>
        <div className='body-wrapper'>
          {currentStep === 0 ? <>
            <FileUpload 
             sampleFileLink={sampleFileLink}
             fileList={fileList}
             setFileData={setFileData}
             setFileList={setFileList}
             setDataToProceed={setDataToProceed}
             setFileColumns={setFileColumns}
             setFileRows={setFileRows}
             bulkAdjustFlag={bulkAddInventory ? false : true}
             showMessage={false}
            />
          </> :
            currentStep === 1 ?
              <div className="box-items-wrapper">
                {dataToProceed?.map((item, index) => {
                    const { data = [], value, label, important, optional } = item;
                    return(
                  <div key={index} className="items">
                    <ReactSelect
                      label={label ? startCase(label) : label}
                      value={fileColumns?.find(col => col?.value === value) || null}  // Ensure UI reflects the state
                      options={fileColumns}
                      placeholder={'Don’t Import'}
                      className="add-product-manual-wrapper"
                      isClearable
                      important={important}
                      optional={optional}
                      onChange={(selectedOption) =>
                      handleFileValueChange(selectedOption?.value, label)
                      }
                    />
                    <div className="value">
                      {/* {item.identifiers.map((identifier, idIndex) => (
                        <p key={idIndex}>{identifier}</p>
                      ))} */}
                       {data?.slice(0, 3)?.map((identifier, idIndex) => (
                              <p key={idIndex}>{identifier}</p>
                            ))}
                    </div>
                  </div>
                    )
               })}
              </div>
              : currentStep === 2 ?
                <div className='box-container'>
                  <div className='header-ui-wrapper'>
                    <span>Row #</span>
                    <span>{bulkAddInventory ? 'Product Identifier' : 'SKU'}</span>
                    <span>{bulkAddInventory ? 'Units' : 'Quantity'}</span>
                    <span>Error Message</span>
                  </div>
                  <div className='scroll-able-content'>
                    {fileRows.filter((row) => row.reason).length === 0 ? (
                          <div className="no-errors-message">
                            <p>No Error Found!.</p>
                          </div>
                        ) :
                          (fileRows
                            .filter((row) => row.reason)
                            .map((item, index) => (
                              <div key={index} className='body-boxes new-content'>
                                  <>
                                    <span>{index+1 || 'N/A'}</span>
                                    <span>{bulkAddInventory ? item['Product Identifier'] : item?.SKU}</span>
                                    <span>{bulkAddInventory ? item['Units'] : item?.Quantity}</span>
                                    <span><img src={ErrorIcon} /> {item?.reason}</span>
                                  </>
                                
                              </div>
                            )))}
                  </div>
                </div>
                : null}
        </div>
      </div>}
      {currentStep === 3 ? (
        <div className="congratulations-wrapper">
          <img src={PartyIcon} title={PartyIcon} alt={PartyIcon} />
          <h1>File Uploaded Successfully</h1>
          {/* <p>Your batch file is successfully uploaded. You can now proceed
          with additional actions on the batches.</p> */}
          <Button onClick={() => clearStates()}  text="Go to Locations Page" />
        </div>
      ) : null}
    </StepDataWrapper>
  )
}

export default StepsData;
